var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "saas-error-page linear-error-page",
      attrs: { id: "wrapper" },
    },
    [
      _c("div", { staticClass: "linear-error-card" }, [
        _c("div", { staticClass: "linear-error-card__code" }, [_vm._v("403")]),
        _vm._v(" "),
        _c("span", { staticClass: "linear-error-card__label" }, [
          _vm._v("Access restricted"),
        ]),
        _vm._v(" "),
        _c("h1", [_vm._v("IP Restricted")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "This IP address is not allowed to access the admin panel. Contact an administrator if you need access."
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "linear-error-card__actions" },
          [
            _c(
              "router-link",
              {
                staticClass:
                  "btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid",
                attrs: { to: "/" },
              },
              [_vm._v(_vm._s(_vm.trans("general.back")))]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }